<div class="custom-accordion">
  <div *ngFor="let section of sections" [id]="'section-' + section.id" class="accordion-section"
    [class.section-open]="section.isOpen" [class.section-completed]="section.isCompleted">

    <!-- Section Header -->
    <div class="section-header" *ngIf="section.hasHeader"
      [ngClass]="{'can-click': !section.hasAddButton && !section.hasCompleteButton}"
      (click)="!section.hasAddButton && !section.hasCompleteButton ? toggleSection(section.id, $event) : null">

      <div class="header-left">

        <!-- Section Title and Subtitle -->
        <div class="header-text">
          <span class="section-title">{{ section.title }}</span>
          <span *ngIf="section.subtitle && !section.isOpen" class="section-subtitle">{{ section.subtitle }}</span>
        </div>
      </div>

      <div class="header-right">
        <!-- Add Button -->
        <hub-button *ngIf="section.hasAddButton" text="{{'bikeshop.shop_profile.collections.buttons.add' | translate}}"
          [disabled]="!buttonEnabled(section.id)" [size]="'sm'" [style]="'borderless-secondary'" [icon]="'plus'"
          (buttonClick)="onAddClick(section.id, $event)">
        </hub-button>

        <!-- Complete Button -->
        <hub-button *ngIf="section.hasCompleteButton" text="{{'general.complete' | translate}}"
          [disabled]="!buttonEnabled(section.id)" [size]="'sm'" [style]="'borderless-secondary'" [icon]="'plus'"
          (buttonClick)="onAddClick(section.id, $event)">
        </hub-button>

        <!-- Chevron Button -->
        <hub-button *ngIf="!section.hasAddButton && !section.hasCompleteButton" [size]="'lg'" [style]="'outline'"
          [icon]="section.isOpen ? 'chevron-up' : 'chevron-down'" (buttonClick)="toggleSection(section.id, $event)">
        </hub-button>
      </div>
    </div>

    <!-- Section Content -->
    <div class="section-content" [class.content-visible]="section.isOpen">

      <div class="content-wrapper" *ngIf="jobcard && jobcard.statusID">

        <div *ngIf="section.id === 'live-status-updates' && section.isOpen">
          <app-workshop-jobcard-live-statuses [jobcard]="jobcard" [serviceTypes]="serviceTypes" [cancelDisabled]="cancelDisabled"
            (jobcardChange)="onJobCardChange($event)"></app-workshop-jobcard-live-statuses>
        </div>

        <div *ngIf="section.id === 'live-updates' && section.isOpen">
          <app-workshop-jobcard-live-updates [jobcard]="jobcard" [serviceTypes]="serviceTypes"
            [goToMessaging]="goToMessaging"
            (jobcardChange)="onJobCardChange($event)"></app-workshop-jobcard-live-updates>
        </div>
        <!-- Services and Products Content -->
        <!-- <div *ngIf="section.id === 'services-products' && section.isOpen">
          <app-workshop-jobcard-quote-search-area [jobcard]="jobcard" [serviceTypes]="serviceTypes"
            (jobcardChange)="onJobCardChange($event)"
            [productSKUServiceTypeCollection]="productSKUServiceTypeCollection"></app-workshop-jobcard-quote-search-area>
        </div> -->

        <!-- Quote Content -->
        <div *ngIf="section.id === 'quote' && section.isOpen">
          <app-workshop-jobcard-quote [jobcard]="jobcard" [serviceTypes]="serviceTypes"
            [productSKUServiceTypeCollection]="productSKUServiceTypeCollection"
            (jobcardChange)="onJobCardChange($event)"></app-workshop-jobcard-quote>
        </div>

        <!-- Notes -->
        <div *ngIf="section.id === 'notes' && section.isOpen">
          <app-workshop-jobcard-live-notes [jobcard]="jobcard"
            (jobcardChange)="onJobCardChange($event)"></app-workshop-jobcard-live-notes>
        </div>

        <div *ngIf="section.id === 'extras' && section.isOpen && showExtras">
            <app-workshop-jobcard-tag-select [jobcard]="jobcard" (tagCount)="setTagCount($event)" ></app-workshop-jobcard-tag-select>
        </div>
        <br/>

      </div>
    </div>
  </div>

</div>
